import type { FitnessWorkoutSet } from '@/lib/fitnessWorkoutController';
import { useLanguage } from '@/i18n/LanguageProvider';
import { getFitnessWorkoutExperienceCopy } from '@/lib/fitnessWorkoutExperienceCopy';
export default function FitnessSetMetadataInput({ set, disabled, onChange }: {
  set: FitnessWorkoutSet; disabled?: boolean;
  onChange: (metadata: { type: 'warmup' | 'working'; rir?: number }) => void;
}) {
  const { lang } = useLanguage(), copy = getFitnessWorkoutExperienceCopy(lang);
  const type = set.type ?? 'working';
  return <details className="mt-3 border-t border-border pt-2"><summary className="min-h-11 cursor-pointer py-3 text-sm font-medium text-primary">{type === 'warmup' ? copy.warmup : copy.working}{set.rir !== undefined && <> · {copy.rir}: {set.rir}</>}</summary><fieldset disabled={disabled} className="grid gap-3 pb-3 sm:grid-cols-2">
    <label className="flex flex-col gap-2 text-sm">{copy.setType}
      <select className="min-h-11 rounded-xl border border-border bg-background px-3" value={type}
        onChange={event => onChange({ type: event.target.value as 'working' | 'warmup', ...(set.rir === undefined ? {} : { rir: set.rir }) })}>
        <option value="working">{copy.working}</option><option value="warmup">{copy.warmup}</option>
      </select>
    </label>
    <label className="flex flex-col gap-2 text-sm">{copy.rir}
      <select className="min-h-11 rounded-xl border border-border bg-background px-3" value={set.rir ?? ''}
        onChange={event => onChange({ type, ...(event.target.value === '' ? {} : { rir: Number(event.target.value) }) })}>
        <option value="">{copy.notRecorded}</option>{Array.from({ length: 11 }, (_, n) => <option key={n} value={n}>{n}</option>)}
      </select>
    </label>
    <p className="text-xs leading-relaxed text-muted-foreground sm:col-span-2">{copy.rirHint}</p>
  </fieldset></details>;
}
